import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../../selectors';
import Channels from './Channels.component';

const ChannelsContainer = props => <Channels {...props} />;

const mapStateToProps = state => ({
	locale: appSelectors.locale.localeSelector(state),
	config: apiSelectors.config.configSelector(state),
	queryParams: appSelectors.ui.queryParamsSelector(state),
	status: apiSelectors.target.statusSelector(state),
	availableChannels: apiSelectors.target.channelsSelector(state),
});

const mapDispatchToProps = () => ({});

ChannelsContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ChannelsContainer);



// WEBPACK FOOTER //
// ./src/ui/channels/Channels.container.js